$(function(){
  $('#footer .navigation .title').click(function(){
    if($(window).width() <= '900') {
      $(this).next('ul').slideToggle();
      $(this).find('i').toggleClass('fa-angle-down').toggleClass('fa-angle-up');
    }
  });

  // check if user successfuly passed Challenge page
  var searchParams = window.location.search
  const isCustomerContactPosted = searchParams.includes('newsletter') && searchParams.includes('prospect');
  if(isCustomerContactPosted && $('#footer .mailing-list form').length > 0){
    //scroll too footer
    location.href = "#footer";
    const tempLocationString = window.location.href.replace('?customer_posted=true#footer', '');
    console.log(tempLocationString);

    // show success message
    $('#footer .mailing-list form').addClass('hide');
    $('#footer .mailing-list .success').removeClass('hide');
    $('#footer .mailing-list .error-msg').addClass('hide');

    // replace page history
    setTimeout(() => {
      window.history.replaceState({}, 'Replaced history state', tempLocationString);
    }, 4000);
  }

  $('#footer .mailing-list form').on('submit', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    var $form = $(this);

    $(this).find('.error').removeClass('error');

    var error = false;
    $(this).find('.required').each(function(){
      if($(this).val()=="") {
        error = true;
        $(this).addClass('error');
        $('#footer .mailing-list .error-msg').show();
        $('#footer .mailing-list .success').addClass('hide');
      }
    });
    if(!error) {
      if(!validateEmail($(this).find('.email').val())) {
        error = true;
        $(this).find('.email').addClass('error');
        $('#footer .mailing-list .error-msg').show();
        $('#footer .mailing-list .success').addClass('hide');
      }
    }

    if(!error) {
      const emailValue = $form.find('.email').val();

      const identifyPayload = {
        "$exchange_id":"V1KL0aUu4X5rwpeaaNdY4OFs4r_jxD1XPiLGbJCeytw=.TtcYai",
        "token":"TtcYai",
        "properties": {
          "$exchange_id":"V1KL0aUu4X5rwpeaaNdY4OFs4r_jxD1XPiLGbJCeytw=.TtcYai",
          "$source": "Newsletter",
          "$email": emailValue
      }};

      fetch('https://a.klaviyo.com/api/onsite/identify?c=TtcYai', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(identifyPayload)
      })
      .then(response => response.json())
      .then(response => {
        fetch('https://a.klaviyo.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
          body: `g=TPfJJ2&%24fields=%24source%2C%24email%2C%24consent_method%2C%24consent_form_id%2C%24consent_form_version%2Cservices&%24list_fields=&%24timezone_offset=3&%24source=Newsletter&%24email=${emailValue}&%24consent_method=Klaviyo+Form&%24consent_form_id=U7imER&%24consent_form_version=5382266&services=%7B%22shopify%22%3A%7B%22source%22%3A%22form%22%7D%7D&%24exchange_id=${response.$exchange_id}`
        })
        .then(response => {
          $(this).find('.email').removeClass('error');
          $('#footer .mailing-list .success').removeClass('hide');
          $('#footer .mailing-list .error-msg').hide();
          document.dispatchEvent(new CustomEvent("email:optin:success", { detail:
            {
              'email': emailValue,
            }
          }));
        })
      })
      .then(response => {
        console.log('response', response);
      })
      .catch((error) => {
        console.error(error);
      })
    }
  });
});